/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ListOfStarredObjects,
  StarredObjectType,
  StarredObjects,
} from "../models/index";
import {
  ListOfStarredObjectsFromJSON,
  ListOfStarredObjectsToJSON,
  StarredObjectTypeFromJSON,
  StarredObjectTypeToJSON,
  StarredObjectsFromJSON,
  StarredObjectsToJSON,
} from "../models/index";

export interface GetStarredObjectsForUserRequest {
  objectType: StarredObjectType;
  userEmail?: string | null;
}

export interface MigrateStarObjectsRequest {
  objectType: StarredObjectType;
  listOfStarredObjects: ListOfStarredObjects;
}

export interface StarObjectsRequest {
  objectIds: Array<string>;
  objectType: StarredObjectType;
  reason?: string | null;
}

export interface UnStarObjectsRequest {
  objectIds: Array<string>;
  objectType: StarredObjectType;
}

export interface UpdateStarReasonRequest {
  starredObjectId: string;
  reason: string;
}

/**
 *
 */
export class StarredObjectsApi extends runtime.BaseAPI {
  /**
   */
  async getStarredObjectsForUserRaw(
    requestParameters: GetStarredObjectsForUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<StarredObjects>>> {
    if (requestParameters["objectType"] == null) {
      throw new runtime.RequiredError(
        "objectType",
        'Required parameter "objectType" was null or undefined when calling getStarredObjectsForUser().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userEmail"] != null) {
      queryParameters["userEmail"] = requestParameters["userEmail"];
    }

    if (requestParameters["objectType"] != null) {
      queryParameters["objectType"] = requestParameters["objectType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/starred-objects/get-starred-objects-for-user`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(StarredObjectsFromJSON),
    );
  }

  /**
   */
  async getStarredObjectsForUser(
    requestParameters: GetStarredObjectsForUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<StarredObjects>> {
    const response = await this.getStarredObjectsForUserRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async migrateStarObjectsRaw(
    requestParameters: MigrateStarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["objectType"] == null) {
      throw new runtime.RequiredError(
        "objectType",
        'Required parameter "objectType" was null or undefined when calling migrateStarObjects().',
      );
    }

    if (requestParameters["listOfStarredObjects"] == null) {
      throw new runtime.RequiredError(
        "listOfStarredObjects",
        'Required parameter "listOfStarredObjects" was null or undefined when calling migrateStarObjects().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["objectType"] != null) {
      queryParameters["objectType"] = requestParameters["objectType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/starred-objects/migrate-star-objects`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ListOfStarredObjectsToJSON(
          requestParameters["listOfStarredObjects"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async migrateStarObjects(
    requestParameters: MigrateStarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.migrateStarObjectsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async starObjectsRaw(
    requestParameters: StarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["objectIds"] == null) {
      throw new runtime.RequiredError(
        "objectIds",
        'Required parameter "objectIds" was null or undefined when calling starObjects().',
      );
    }

    if (requestParameters["objectType"] == null) {
      throw new runtime.RequiredError(
        "objectType",
        'Required parameter "objectType" was null or undefined when calling starObjects().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["objectIds"] != null) {
      queryParameters["objectIds"] = requestParameters["objectIds"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["objectType"] != null) {
      queryParameters["objectType"] = requestParameters["objectType"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/starred-objects/star-objects`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async starObjects(
    requestParameters: StarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.starObjectsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async unStarObjectsRaw(
    requestParameters: UnStarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["objectIds"] == null) {
      throw new runtime.RequiredError(
        "objectIds",
        'Required parameter "objectIds" was null or undefined when calling unStarObjects().',
      );
    }

    if (requestParameters["objectType"] == null) {
      throw new runtime.RequiredError(
        "objectType",
        'Required parameter "objectType" was null or undefined when calling unStarObjects().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["objectIds"] != null) {
      queryParameters["objectIds"] = requestParameters["objectIds"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["objectType"] != null) {
      queryParameters["objectType"] = requestParameters["objectType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/starred-objects/unstar-objects`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async unStarObjects(
    requestParameters: UnStarObjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.unStarObjectsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateStarReasonRaw(
    requestParameters: UpdateStarReasonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["starredObjectId"] == null) {
      throw new runtime.RequiredError(
        "starredObjectId",
        'Required parameter "starredObjectId" was null or undefined when calling updateStarReason().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling updateStarReason().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["starredObjectId"] != null) {
      queryParameters["starredObjectId"] = requestParameters["starredObjectId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/starred-objects/update-star-reason`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateStarReason(
    requestParameters: UpdateStarReasonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateStarReasonRaw(requestParameters, initOverrides);
  }
}
